export const ACCESS_TOKEN_NAME = 'accessToken';
export const ACCESS_TOKEN_USER = 'accessTokenUser';
// Long-lived refresh token minted alongside the 12h access token by
// /api/my-pages/auth. Stored in localStorage so the axios interceptor can
// silently swap in a fresh access token when the current one expires,
// giving the intended 30-day session without a forced re-login every 12h.
export const REFRESH_TOKEN_NAME = 'refreshToken';
